import module from 'viaticos/module.js'

export class ViaticosColaboradorCuentacontableService {
  constructor ($http) {
    this.$http = $http
  }

  post (id_proyecto, id_colaborador, cuenta) {
    return this.$http.post('/api/viaticos/colaborador/cuentacontable', {cuenta: cuenta}, {
      params: {
        id_colaborador: id_colaborador,
        id_proyecto: id_proyecto,
      },
    })
  }

  put (id_proyecto, id_colaborador, cuenta) {
    return this.$http.put('/api/viaticos/colaborador/cuentacontable', {cuenta: cuenta}, {
      params: {
        id_colaborador: id_colaborador,
        id_proyecto: id_proyecto,
      },
    })
  }
}

module.service('ViaticosColaboradorCuentacontableService', ViaticosColaboradorCuentacontableService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Colaborador/Cuentacontable.js